import { useState } from 'react';
import { Dayjs } from 'dayjs';
import { PaymentSettingLogsParams } from '../../../lib/api/pgProviderRoute';

export const PAYMENT_LOG_LIMIT = 50;
export type PaymentLogDateRange = [Dayjs | null, Dayjs | null] | null;

export const usePaymentSettingLogFilters = () => {
  const [target, setTarget] = useState<NonNullable<PaymentSettingLogsParams['target']> | 'all'>('all');
  const [adminName, setAdminName] = useState('');
  const [dateRange, setDateRange] = useState<PaymentLogDateRange>(null);
  const [params, setParams] = useState<PaymentSettingLogsParams>({ limit: PAYMENT_LOG_LIMIT });
  const [page, setPage] = useState(1);

  const apply = (): void => {
    setPage(1);
    setParams({
      limit: PAYMENT_LOG_LIMIT,
      ...(target !== 'all' ? { target } : {}),
      ...(adminName.trim() ? { adminName: adminName.trim() } : {}),
      ...(dateRange?.[0] ? { fromDate: dateRange[0].format('YYYY-MM-DD') } : {}),
      ...(dateRange?.[1] ? { toDate: dateRange[1].format('YYYY-MM-DD') } : {}),
    });
  };
  const reset = (): void => {
    setTarget('all');
    setAdminName('');
    setDateRange(null);
    setPage(1);
    setParams({ limit: PAYMENT_LOG_LIMIT });
  };
  return { target, setTarget, adminName, setAdminName, dateRange, setDateRange, params, page, setPage, apply, reset };
};
